// extracted by css-extract-rspack-plugin
export default {"strikePriceInfo":"product-detail-fragment__StrikePriceInfo_strikePriceInfo__fLgp5"};